import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmRadioGroup, mmRadioGroupOptions } from "@/types";

class RadioGroup extends Component<mmRadioGroupOptions> implements mmRadioGroup {
  private _dxRadioGroup!: DevExpress.ui.dxRadioGroup;

  constructor(element: HTMLElement, options?: mmRadioGroupOptions) {
    super(element, options);

    const dxOptions: DevExpress.ui.dxRadioGroupOptions = {
        accessKey: this._options.accessKey,
        activeStateEnabled: this._options.activeStateEnabled,
        dataSource: this._options.dataSource,
        disabled: this._options.disabled,
        displayExpr: this._options.displayExpr,
        elementAttr: {
          class: generateClassName(
            "radio",
            this._options.color!,
            this._options.size!,
            // this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },
        focusStateEnabled: this._options.focusStateEnabled,
        height: this._options.height,
        hint: this._options.hint,
        hoverStateEnabled: this._options.hoverStateEnabled,
        isDirty: this._options.isDirty,
        isValid: this._options.isValid,
        // itemComponent: this._options.itemComponent,
        // itemRender: this._options.itemRender,
        // items: this._options.items,
        itemTemplate: this._options.itemTemplate,
        layout: this._options.layout,
        name: this._options.name,
        onContentReady: this._options.onContentReady,
        onDisposing: this._options.onDisposing,
        onOptionChanged: this._options.onOptionChanged,
        onInitialized: this._options.onInitialized,
        onValueChanged: this._options.onValueChanged,
        readOnly: this._options.readOnly,
        rtlEnabled: this._options.rtlEnabled,
        tabIndex: this._options.tabIndex,
        validationError: this._options.validationError,
        validationErrors: this._options.validationErrors,
        validationMessageMode: this._options.validationMessageMode,
        validationMessagePosition: this._options.validationMessagePosition,
        value: this._options.value,
        visible: this._options.visible,
        valueExpr: this._options.valueExpr,
        width: this._options.width,
        // shape: this._options.shape,
      } 
      
      if (this._options.dataSource) {
      dxOptions.dataSource = this._options.dataSource;
    } else if (this._options.items) {
      dxOptions.items = this._options.items;
    }

    // dxRadioGroup instance oluştur
    this._dxRadioGroup = ($(this._element) as any)
      .dxRadioGroup(dxOptions)
      .dxRadioGroup("instance");
  }

  public get value(): boolean {
    return this._dxRadioGroup.option("value") ?? false;
  }

  public set value(val: boolean) {
    this._dxRadioGroup.option("value", val);
  }

  public get readOnly(): boolean {
    const val = this._dxRadioGroup.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxRadioGroup.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxRadioGroup.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxRadioGroup.option("disabled", val);
  }

  public getDefaults(): Partial<mmRadioGroupOptions> {
    return {
      color: "primary",
      size: "md",
      // shape: "round",
      visible: true,
      itemTemplate: "item",
      rtlEnabled: false,
      isValid: true,
      layout: "vertical",
      validationStatus: "valid",
    };
  }
}

registerComponent("mmRadioGroup", RadioGroup);

export default RadioGroup;
